<script lang="ts">
    import InputCheckbox from "../Form/InputCheckbox.svelte";
    import {reminderSchema} from "../../validationsForm/reminderValidation.ts";
    import {createEventDispatcher} from "svelte";

    let requirement = {
        first_reminder: false,
        second_reminder: false,
        third_reminder: false,
        fourth_reminder: false,
        fifth_reminder: false,
        sixth_reminder: false,
        seventh_reminder: false
    }

    let errors = {};
    const dispatch = createEventDispatcher();
    async function reminderValidation() {
        try{
            await reminderSchema.validate(requirement, {abortEarly: false})
            errors = {};

            dispatch('requirementForm', {
                requirementFormStatus: true,
                requirementModalStatus: false,
            });
        }
        catch (err) {

            return errors = err.inner.reduce((acc, err) => {
                return ( { ...acc, [err.path]: err.message });
            }, {});
        }
    }
</script>

<div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-content">
        <div class="box is-flex is-justify-content-center is-flex-direction-column">
            <div class="content">
                <slot name="button"></slot>
                <h3 class="has-text-centered title is-3 mt-0">Rappels pour chaque commande avant inscription.</h3>
                <div class="is-flex is-justify-content-center">
                    <em>Vous pourrez retrouver ces rappels dans la section "Documentation" de votre compte</em>
                </div>
                <div class="is-flex is-justify-content-center">
                    <form id="reminder-form" on:submit|preventDefault={reminderValidation}>
                        <div class="info-content-container">
                            <InputCheckbox bind:checked={requirement.first_reminder} error={errors.first_reminder} name="first-reminder" label="Pour être sûr de ne pas manquer de produit lors de la livraison, merci de calculer votre cubage prévisionnel avec une marge de 10% supplémentaires. La masse chargée sera facturée en totalité en cas de surcharge inutile excessive (> 20 %)."/>
                            <InputCheckbox bind:checked={requirement.second_reminder} error={errors.second_reminder} name="second-reminder" label="Le chantier doit être obligatoirement muni d'un point d'eau, avec une pression minimum de 3 à 4 bars. Tout branchement illégal sera, bien entendu, à votre charge. Pour information, en cas d'absence de point d'eau, une demande de raccordement peut être faite, au préalable, auprès des services d'eaux/communaux & par vos soins."/>
                            <InputCheckbox bind:checked={requirement.third_reminder} error={errors.third_reminder} name="third-reminder" label="Prévoir l'accessibilité pour un semi-remorque (Hauteur sur route : 4 m / Hauteur libre sur chantier : 9 m au-dessus de la centrale). Si besoin, faire une demande d'autorisation de stationnement pour la centrale auprès de la commune."/>
                            <InputCheckbox bind:checked={requirement.fourth_reminder} error={errors.fourth_reminder} name="fourth-reminder" label="Le pompage doit avoir lieu au maximum dans la demi-heure suivant l'arrivée de notre camion sur votre chantier. Passé ce délai, les heures de main d'œuvre pourront vous être facturées."/>
                            <InputCheckbox bind:checked={requirement.fifth_reminder} error={errors.fifth_reminder} name="fifth-reminder" label="Le matériel ne permet pas de conserver les résidus de produit ; Merci de prévoir l'évacuation des eaux de nettoyage de notre centrale mobile. Tout chantier sans point de nettoyage sera annulé par nos soins mais le déplacement vous sera malgré tout facturé."/>
                            <InputCheckbox bind:checked={requirement.sixth_reminder} error={errors.sixth_reminder} name="sixth-reminder" label="Un bon de commande par jour et par chantier. Pour des raisons d'organisation, les bons de commande doivent nous parvenir, au maximum, la veille du chantier avant 10:00. Passé ce délai, les coulages pourront être réattribués à un autre client."/>
                            <InputCheckbox bind:checked={requirement.seventh_reminder} error={errors.seventh_reminder} name="seventh-reminder" label="Pour la mise en œuvre, se reporter au document technique et aux textes en vigueur."/>
                        </div>
                        <div class="info-button-container is-flex is-justify-content-center mt-3">
                            <button class="button is-success" type="submit">Valider</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>